module.exports = __webpack_public_path__ + "img/share_btn.0a0dd26b.png";